import { Button } from '@mui/material';
import React from 'react';
import { FiArrowLeft, FiX } from 'react-icons/fi';
import styles from './styles';

const CloseButton = ({onClick, variant, sx}) => {


    const handleClick = (event) => {

        if(typeof onClick === 'function'){
            onClick(event);
        }
    }


    return (
        <Button 
            className='follow-close-button' 
            sx={{
                ...styles.closeButton,
                ...sx
            }} 
            variant={ variant || 'main'}
            onClick={handleClick}>

                {

                    <FiX />
                }
                
        </Button>
    );
}

export default CloseButton;